import NiceModal from '@ebay/nice-modal-react';
import { isNilOrEmpty } from 'ramda-extension';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';
import { setValue } from '@gef-ui/form-core/stream/transfer/control';

import MODALS from 'constants/modals';
import { KCL_DOCUMENT_CHECK_ADMINS, KCL_DOCUMENT_CHECK_MARPO } from 'features/common/acl/constants';
import fetch from 'features/common/fetch';
import { urls } from 'features/common/fetch/constants';
import { saveFile } from 'features/common/fileSave/actions';
import {
	FIELDS,
	REPORT_PRODUCTION_CONTROL_FORM_NAME,
} from 'features/views/productionControl/reportProductionControl/form';
import { SELECTION_CRITERIA_FORM_NAME } from 'features/views/productionControl/selectionCriteria/form';
import { cleanse } from 'utils';

import { getRegions } from '../selectors';
import { getCheckedWavesIds } from './selectors';
import {
	resetCheckedWavesIds,
	resetModalSubordinates,
	resetModalSuperiors,
	setModalSubordinates,
	setModalSuperiors,
} from './slice';

export const startupModal =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		const userIsMarpo = hasPermissionByIds(getState())(KCL_DOCUMENT_CHECK_MARPO);
		const regions = getRegions(getState());

		if (userIsMarpo) {
			const firstRegion = regions[0];

			sendControlNext(
				REPORT_PRODUCTION_CONTROL_FORM_NAME,
				setValue({ fieldName: FIELDS.region, value: firstRegion?.id }),
			);
		}
	};

export const resetReportModal = () => (dispatch) => {
	dispatch(resetModalSuperiors());
	dispatch(resetModalSubordinates());
	dispatch(resetCheckedWavesIds());
};

export const fetchSuperiorsForReportModal =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const userIsCentralOrMarpo = hasPermissionByIds(getState())([
			...KCL_DOCUMENT_CHECK_ADMINS,
			...KCL_DOCUMENT_CHECK_MARPO,
		]);
		const checkedWaves = getCheckedWavesIds(getState());
		const waveId = checkedWaves.join(',');
		const reportModalFormData = await getFormData(REPORT_PRODUCTION_CONTROL_FORM_NAME);

		if (userIsCentralOrMarpo && !isNilOrEmpty(reportModalFormData?.region) && !isNilOrEmpty(checkedWaves)) {
			dispatch(
				fetch.actions.get(urls.koprSuperiors, {
					queryParams: {
						waveId,
						regionId: reportModalFormData?.region,
					},
					onSuccess: [
						(response) => () => {
							if (!response || !response.body) return;
							const data = response?.body;
							const values = data?.values;

							dispatch(setModalSuperiors(values));
						},
					],
				}),
			);
		}
	};

export const fetchSubordinatesForReportModal =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const userIsCentralOrMarpo = hasPermissionByIds(getState())([
			...KCL_DOCUMENT_CHECK_ADMINS,
			...KCL_DOCUMENT_CHECK_MARPO,
		]);
		const checkedWaves = getCheckedWavesIds(getState());
		const waveId = checkedWaves.join(',');

		const reportModalFormData = await getFormData(REPORT_PRODUCTION_CONTROL_FORM_NAME);

		if (userIsCentralOrMarpo && !isNilOrEmpty(reportModalFormData?.superior) && !isNilOrEmpty(checkedWaves)) {
			dispatch(
				fetch.actions.get(urls.koprSubordinates, {
					queryParams: {
						waveId,
						superiorOid: reportModalFormData?.superior,
					},
					onSuccess: [
						(response) => () => {
							if (!response || !response.body) return;
							const data = response?.body;
							const values = data?.values;

							dispatch(setModalSubordinates(values));
						},
					],
				}),
			);
		}
	};

export const reportKopr =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const userIsCentralOrMarpo = hasPermissionByIds(getState())([
			...KCL_DOCUMENT_CHECK_ADMINS,
			...KCL_DOCUMENT_CHECK_MARPO,
		]);

		let queryParams;

		if (userIsCentralOrMarpo) {
			const reportModalFormData = await getFormData(REPORT_PRODUCTION_CONTROL_FORM_NAME);
			const checkedWaves = getCheckedWavesIds(getState());
			const waveId = checkedWaves.join(',');

			queryParams = cleanse({
				waveId,
				regionId: reportModalFormData?.region,
				superiorOid: reportModalFormData?.superior,
				solverOid: reportModalFormData?.subordinate,
			});
		} else {
			const selectionCriteriaFormData = await getFormData(SELECTION_CRITERIA_FORM_NAME);

			queryParams = {
				waveId: selectionCriteriaFormData?.wave,
			};
		}
		dispatch(
			fetch.actions.getBinary(urls.koprReport, {
				queryParams,
				onSuccess: [
					(response) => () => {
						if (!response || !response.body) return;
						NiceModal.hide(MODALS.productionControl_report);
						saveFile({ response });
					},
				],
			}),
		);
	};
